<template>
  <div>
    <p class="h3 mb-2 pt-2 pb-4">Dans quelle pièce souhaitez-vous installer votre radiateur ? </p>

    <div class="form-check check-tile mb-3" @click="selectTowelRoom('salle-de-bain')">
      <input class="form-check-input d-none" type="radio" name="piece" id="piece-1" value="option1" checked>
      <router-link :to="{name:routerTo}" tag="label" class="form-check-label" for="piece-1">
        <div class="d-flex align-items-center">
          <img src="../assets/img/pieces/salle-de-bain.svg">
          <p class="ml-4 mb-0 lead">Salle de bain</p>
        </div>
        <i class="fal fa-arrow-right fa-2x text-primary"></i>
      </router-link>
    </div>

    <div class="form-check check-tile mb-3" @click="selectTowelRoom('sejour')">
      <input class="form-check-input d-none" type="radio" name="piece" id="piece-2" value="option2">
      <router-link :to="{name:routerTo}" tag="label" class="form-check-label" for="piece-2">
        <div class="d-flex align-items-center">
          <img src="../assets/img/pieces/sejour.svg">
          <p class="ml-4 mb-0 lead">Séjour</p>
        </div>
        <i class="fal fa-arrow-right fa-2x text-primary"></i>
      </router-link>
    </div>

    <div class="form-check check-tile mb-3" @click="selectTowelRoom('chambre')">
      <input class="form-check-input d-none" type="radio" name="piece" id="piece-3" value="option2">
      <router-link :to="{name:routerTo}" tag="label" class="form-check-label" for="piece-3">
        <div class="d-flex align-items-center">
          <img src="../assets/img/pieces/chambre.svg">
          <p class="ml-4 mb-0 lead">Chambre</p>
        </div>
        <i class="fal fa-arrow-right fa-2x text-primary"></i>
      </router-link>
    </div>

    <div class="form-check check-tile" @click="selectTowelRoom('cuisine')">
      <input class="form-check-input d-none" type="radio" name="piece" id="piece-4" value="option2">
      <router-link :to="{name:routerTo}" tag="label" class="form-check-label" for="piece-4">
        <div class="d-flex align-items-center">
          <img src="../assets/img/pieces/cuisine.svg">
          <p class="ml-4 mb-0 lead">Cuisine</p>
        </div>
        <i class="fal fa-arrow-right fa-2x text-primary"></i>
      </router-link>
    </div>

  </div>
</template>

<script>
export default {
  name: "RoomType",
  // mounted(){
  //   if (this.state.power_selected!==1000)this.setData('power_selected',1000);
  // },
  methods:{
    selectTowelRoom(room){
      this.setData('room_type',room)
      if (room=='cuisine'||room=='salle-de-bain')this.setDataRad('towelDryers','2')
      else this.setDataRad('towelDryers','0')
    }
  },
  computed:{
    routerTo(){
      if (this.state.known_power)return 'PowerSelection';
      else return 'SurfaceSelection';
    }
  }
}
</script>

<style scoped>

</style>